export {
    sleep,
    fetchRetry,
    render,
    mediaQuery,
    istDesktop,
    istTablet,
    istTabletDown,
    istMobil,
    istIE,
    breiteGesamt,
    hoeheGesamt,
    paddingRechtsLinks,
    getCookie,
    updateCsrfToken,
};

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
}

/**
 * Custom fetch mit Retry
 * @param {string} uri - URI zur Resource
 * @param {object} options - fetch options
 * @param {number} n - Anzahl der Versuche/Retries
 * @param {number} t - Verzögerung zwischen den Versuchen in ms
 * @returns {object}
 */
function fetchRetry(url, options, n, t = 1000) {
    return fetch(url, options)
        .then((response) => {
            if (response.ok) return response;
            throw new Error("Network response was not ok");
        })
        .catch(async (error) => {
            console.log(`Verbleibende Versuche: ${n - 1}`)
            if (n === 1) throw error;
            await sleep(t);
            return fetchRetry(url, options, n - 1);
        })
}

async function render(container, html) {
    const range = document.createRange();
    range.setStart(document.documentElement, 0);
    container.innerHTML = '';
    await container.appendChild(
        range.createContextualFragment(html)
    );
}

function mediaQuery(property, value) {
    return window.matchMedia(`screen and (${property}:${value}px)`).matches;
}

function istDesktop() {
    return mediaQuery('min-width', 801);
}

function istTablet() {
    return mediaQuery('min-width', 481);
}

function istTabletDown() {
    return mediaQuery('max-width', 800);
}

function istMobil() {
    return mediaQuery('max-width', 480);
}

// Prüft, ob IE/Edge oder anderer Browser
// Gibt true zurück, wenn IE.
// Gibt false zurück, wenn anderer Browser (nicht IE oder Edge).
function istIE() {
    const ua = window.navigator.userAgent;
    // IE 10 oder älter
    const msie = ua.indexOf('MSIE ');
    if (msie > 0) return true;
    // IE 11
    const trident = ua.indexOf('Trident/');
    if (trident > 0) return true;
    // Modern Browser
    return false;
}

function hoeheGesamt(element) {
    const elementStyle = element.currentStyle || window.getComputedStyle(element);
    const height = element.offsetHeight;
    const margin = parseFloat(elementStyle.marginTop) + parseFloat(elementStyle.marginBottom);
    const padding = parseFloat(elementStyle.paddingTop) + parseFloat(elementStyle.paddingBottom);
    const border = parseFloat(elementStyle.borderTopWidth) + parseFloat(elementStyle.borderBottomWidth);
    return height + margin + padding + border;
}

function breiteGesamt(element) {
    const elementStyle = element.currentStyle || window.getComputedStyle(element);
    const width = element.offsetWidth;
    const margin = parseFloat(elementStyle.marginRight) + parseFloat(elementStyle.marginLeft);
    const padding = parseFloat(elementStyle.paddingRight) + parseFloat(elementStyle.paddingLeft);
    const border = parseFloat(elementStyle.borderRightWidth) + parseFloat(elementStyle.borderLeftWidth);
    return width + margin + padding + border;
}

function paddingRechtsLinks(element) {
    const elementStyle = element.currentStyle || window.getComputedStyle(element);
    return parseFloat(elementStyle.paddingRight) + parseFloat(elementStyle.paddingLeft);
}

/**
 * @param {string} name
 * @returns {string|null}
 */
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    return null;
}

/**
 * @param {string} selector
 */
function updateCsrfToken(selector) {
    const token = getCookie('csrf_global');
    if (token && token.length > 0) {
        document.querySelectorAll(selector).forEach(csrfInput => csrfInput.setAttribute('value', token));
    }
}

